import { Component } from '@angular/core';

@Component({
  selector: 'atlas-header',
  template: '<ng-content></ng-content>',
  standalone: false
})
export class HeaderContentComponent {}

@Component({
  selector: 'atlas-footer',
  template: '<ng-content></ng-content>',
  standalone: false
})
export class FooterContentComponent {}
